import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ConsoleService } from "src/app/core/services/console.service";

@Component({
    selector: "app-text-dialog",
    templateUrl: "./get-text-dialog.html",
    styleUrls: ["./get-text-dialog.scss"],
    standalone: false
})
export class GetTextDialogComponent implements OnInit {
  constructor(
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    ConsoleService.info("component loaded", data);
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
}
